/* eslint-disable react/no-array-index-key */

import { Radio, RadioGroup } from '@mui/material';
import { Tag, WarningTips, WrongInfo } from '@components';
import { ShipmentStatus, ClaimType } from '@constants';
import { useNavigate } from 'react-router-dom';
import { RemarkPanel } from '@/components/choose/remark-panel';
import { useSelector } from 'react-redux';
import classes from './index.module.css';
import { useChoose } from './hooks';

const HAS_CLAIME_TEXT = 'This package already has a reported issue.';
const PackageRadioGroup = () => {
  const {
    delayPackageId,
    type,
    onChange,
    onClickTitle,
    handleWrongMessageClick,
  } = useChoose();
  const navigate = useNavigate();
  const { dhgateFulfillments } = useSelector((state) => state.claim);

  const handleItemClick = (item) => {
    navigate(`../feedback?claimId=${item.claimId}`);
  };

  return (
    <RadioGroup>
      {dhgateFulfillments.map((packageItem) => {
        const {
          fulfillmentId, selectable, trackingCompany, trackingNumber, status, reason, claimId,
        } = packageItem;
        return (
          <section key={fulfillmentId} className={classes.radio}>
            <section className={classes.radio_line}>
              <Radio
                color="input"
                onChange={onChange}
                value={fulfillmentId}
                style={{
                  padding: '0PX',
                  marginRight: '8PX',
                }}
                checked={fulfillmentId === delayPackageId}
                disabled={(type !== ClaimType.Damage && !!packageItem?.claimId) || !selectable}
              />
              <section className={classes.radio_content}>

                <section onClick={() => onClickTitle(packageItem)} className={classes.order_name}>
                  <section className={classes.package_item_title}>{trackingCompany}</section>
                  <section>{trackingNumber}</section>
                </section>
                <section className={classes.radio_right}>
                  <Tag
                    color={status === ShipmentStatus.Delivered ? '#AEE9D1' : '#E4E5E7'}
                    text={status === ShipmentStatus.Delivered ? 'Delivered' : 'Undelivered'}
                  />
                  {/* pc显示 */}
                  {
                    !(status === ShipmentStatus.Delivered) ? (
                      <section className={classes.wrong_pc}><WrongInfo handleClick={() => handleWrongMessageClick(status, trackingNumber)} /></section>
                    ) : null
                  }
                </section>
                {/* mobile显示 */}
                {
                !(status === ShipmentStatus.Delivered) ? (
                  <section className={classes.wrong_mobile}><WrongInfo handleClick={() => handleWrongMessageClick(status, trackingNumber)} /></section>
                ) : null
              }
              </section>

            </section>
            {!claimId && !selectable && reason && (
              <WarningTips text={reason} />
            )}
            {claimId
              ? (
                <RemarkPanel
                  title={HAS_CLAIME_TEXT}
                  btnText="View issue &gt; "
                  isShow={false}
                  onClick={() => handleItemClick(packageItem)}
                />
              )

              : null}
          </section>
        );
      })}
    </RadioGroup>
  );
};

export default PackageRadioGroup;
